import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import SystemMessageType from '@/enums/SystemMessageType'

export class SystemMessage extends Model {
	protected jsonApiType: string = 'system-messages'

	@Property()
	public title!: string | null

	@Property()
	public content!: string | null

	@Property('type')
	public messageType!: SystemMessageType | null

	@Property()
	public showDate!: string | null

	@Property()
	public startAt!: string | null

	@Property()
	public endAt!: string | null

	@Property()
	public createdAt!: string | null

	@Property()
	public updatedAt!: string | null
}
